import {
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
  NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM,
  NODE_TYPE_UBD_CURRICULUM_PROGRAM,
  NODE_TYPE_IB_DP_CURRICULUM_PROGRAM,
} from "Constants/stringConstants";

export const BLUEPRINT_TEACHER_COURSE_SYNC_PERMISSION =
  "FeatureFlag:BluePrintTeacherCourseSync";

export const CURRICULUM_PROGRAM_TO_LEARNING_STANDARD_MAP = {
  [NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM]: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  [NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM]: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  [NODE_TYPE_UBD_CURRICULUM_PROGRAM]: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  [NODE_TYPE_IB_DP_CURRICULUM_PROGRAM]: ELEMENT_TYPE_DP_LEARNING_STANDARD,
};
